<div
  class="chat-message"
  [class.user]="message().role === 'user'"
  [class.assistant]="message().role === 'assistant'"
>
  <div class="message-content">
    @if (message().role === 'assistant') {
      <markdown [data]="message().content"></markdown>
      @if (message().isStreaming) {
        <span class="streaming-cursor"></span>
      }
    } @else {
      <p>{{ message().content }}</p>
    }
  </div>
  <div class="message-time">
    {{ message().timestamp | date: 'shortTime' }}
  </div>
</div>
